import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { AesEncDecService } from '../services/aes/aes-enc-dec.service';
import { inject } from '@angular/core';
import { IJwt } from '../models/jwt/ijwt';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
 
  // Inject the current `AuthService` and use it to get an authentication token:
  const security = inject(AesEncDecService);
  const tokenInfo: IJwt = JSON.parse(security?.getData("accessToken")?.toString() || '{}');
  if (Object.keys(tokenInfo).length != 0 ) {
        // Clone the request to add the authentication header.
    req = req.clone({
      headers: req.headers.append('Authorization', 'Bearer ' + tokenInfo.accessToken),
    });
  }
  return next(req);
}